import { Box, Container } from '@mui/material';
import Loading, { LoadingBall } from '@ingka/loading';

import styled from '@emotion/styled';

const StyledLoading = styled(Loading)`
  height: 500px
`;

export const LoginLoading = () => {
   return (
      <Container component='main' maxWidth='xs'>
         <Box
            sx={{
               marginTop: 8,
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center'
            }}
         >
            <StyledLoading text='Logging in...' labelTransitions>
               <LoadingBall color='primary' />
            </StyledLoading>
         </Box>
      </Container>

   );
};